import capitalize from 'lodash/fp/capitalize';
import { SolveWidgetProduct } from 'src/types/types';
import { ConversationChannel } from 'src/types/workflowBuilderAPITypes';

type Channels = SolveWidgetProduct;

export const formatProductLabel = (product: Channels): string => {
  switch (product) {
    case 'api':
      return 'Headless';
    case 'workflow_builder':
      return 'Widget';
    case 'playbook':
      return 'Assist';
    case 'interactive_email':
      return 'Email';
    default:
      return capitalize(product);
  }
};

/**
 * Maps a SolveWidgetProduct to the channel string expected by IntentBadge.
 */
export const mapProductToChannel = (
  product: Channels | undefined,
): ConversationChannel | undefined => {
  if (product === 'workflow_builder') {
    return 'widget';
  }
  if (product === 'interactive_email') {
    return 'email';
  }
  return product as ConversationChannel | undefined;
};

export const formatProductChannels = (
  products: Channels[],
  productForWorkflowId?: Channels,
): string => {
  if (products.length > 0) {
    return products.map(product => formatProductLabel(product)).join(', ');
  }

  if (productForWorkflowId) {
    return formatProductLabel(productForWorkflowId);
  }

  return 'All channels';
};
